export interface CategoriesForm {
  subcategory_ids: string[];
}
